export const AppleLoginExperimentKey = 'KRK-665-AT';
export const appleLogin = {
    [AppleLoginExperimentKey]: {
        experimentId: '6301773913128960',
        variantsIds: {
            A: '5315824844537856', // Original
            B: '5806108447604736', // Variation #1
        },
    },
};
//# sourceMappingURL=appleLogin.js.map